const timestampToISO = timestamp => {
  //const newTimeStamp = timestamp + 72000000 // adding 20 hours
  //const date = new Date(newTimeStamp);
  const date = new Date(timestamp);
  const utcDate = new Date(
    date.getTime() + Math.abs(date.getTimezoneOffset()) * 60000
  );

  //return date.toISOString()
  return utcDate.toISOString();
};

export default timestampToISO;
